export const TOASTS_WORKER = 'worker'
export const TOASTS_LIFE_DEFAULT = 5000
export const TOASTS_LIFE_LONG = 2 * TOASTS_LIFE_DEFAULT
